import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthContext } from "../hooks/Auth";

const PublicRoutes = ({ children }: { children: React.ReactNode }) => {
  const { isUserAuthenticated } = useAuthContext();

  return isUserAuthenticated ? <Navigate to={"/asistente/menu"} /> : children;
};

export default PublicRoutes;
